import { Component, Inject, Injectable, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/services/auth.service';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { de, es } from 'date-fns/locale';

interface DocumentCategory {
  id: string;
  title: string;
  count: number;
  icon: string;
  isActive: boolean;
  documentTypes?: string[]; // For identity category
}

@Component({
    selector: 'app-share-documents-dialog',
    templateUrl: './share-documents-dialog.component.html',
    styleUrls: ['./share-documents-dialog.component.css'],
    standalone: false
})

export class ShareDocumentsDialogComponent {
  searchForm: FormGroup;
  selectedCategories: any[] = [];
  care_team_list: any;
  searchText: any = '';
  files: any[] = [];
  selectedDocs: any[] = [];

  doctypeMap: { [key: string]: string } = {
    driver_license: 'Driver\'s Licence',
    aadhar: 'AADHAR Card',
    pancard: 'PAN Card',
    passport: 'Passport',
    voterid: 'Voter ID',
    nic: 'National Identity Card',
    ssc: 'Social Security Card',
    tfn: 'Tax Filing Number',
    nino: 'National Insurance Number',
    nhsn: 'National Health Service Number',
     pio: 'PIO (Person of Indian Origin)',
    oci: 'OCI (Overseas Citizen of India)',
    sic: "Social Insurance Card",
    cpf: 'Cadastro de Pessoas Físicas (CPF)',
    birth_number: 'Birth Number',
    cvr_number: 'CVR Number',
    vat_number: 'VAT Registration Number',
    hetu: 'Personal Identification Number',
    hic: 'Health Insurance Card',
    nhi: 'National Health Index Number',
    tin: 'Tax Identification Number',
    pesel_number: 'PESEL Number',
    regon: 'REGON - Identification for Business',
    hun: 'Health User Number',
    ic_number: 'Civil Identification Number',
    nie: 'NIE (Foreigner Identification Number)',
    con: 'Co-Ordination Number',
    orn: 'Organisation Number',
  };
  index_country = "citizen_primary";
  tagSelected='identity';

  docType: any;
  citizen: any[] = [];

  documentCategories: DocumentCategory[] = [
    { id: 'identity', title: 'Identity', count: 0, icon: 'person', isActive: true },
    { id: 'personal', title: 'Personal', count: 0, icon: 'person', isActive: true },
    { id: 'health', title: 'Health', count: 0, icon: 'favorite', isActive: false },
    { id: 'legal', title: 'Legal', count: 0, icon: 'gavel', isActive: false },
    { id: 'finance', title: 'LegalFinance', count: 0, icon: 'folder', isActive: false },
  ];

  getTagId:any;
  allFiles: any[] = [];
  getCatgory: any[] = [];
  noDocumentsFound = false;
  isCategoryInitialized = false;

  constructor(
    private fb: FormBuilder, private authService: AuthService, public toast: ToastrService, public send_menu_request_dialog: MatDialog,
    private dialogRef: MatDialogRef<ShareDocumentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.searchForm = this.fb.group({
      categories: ['', Validators.required],
      searchQuery: ['']
    });
  }

  ngOnInit() {
    console.log('share data:', this.data);
    // console.log('Default category:', this.data.defaultCategory);
    // console.log('All categories:', this.data.categories); 
    // console.log('getCatgory:', this.getCatgory);

    // this.authService.care_team_list_all().subscribe((res: any) => {
    //   this.care_team_list = res.consumers;
    // })

    this.searchForm = this.fb.group({
      categories: [''],
      country: [''],
      searchQuery: ['']
    });

    // Set the default selected category
    if (this.data.defaultCategory) {
      this.searchForm.get('categories')?.setValue([this.data.defaultCategory]);
      this.selectedCategories = [this.data.defaultCategory];
    }

    this.searchForm.get('searchQuery')?.valueChanges.subscribe(value => {
      this.searchText = value;
    });

    this.getCitizenships();
    //this.loadCategories(); //categories
    //this.getIdentityCitizen(); //identity cat

    // NOTE: previously this block pre-set the "categories" control to a plain
    // ID string (matchingCategory.id) sourced from the parent-supplied
    // `data.categories` list. That string doesn't match the { id, tagname }
    // object shape used everywhere else (loadDocuments()/onShare() read
    // categoryObj?.id and categoryObj?.tagname), and because it ran before
    // loadCategories() had fetched the live "LegalFinance" tag, it caused a
    // stray request with an "undefined" category id. Category selection is
    // now always driven by loadCategories() picking "LegalFinance" from the
    // live getTags() response, so this legacy assignment is disabled.
    // const defaultCatTitle = this.data.defaultCategory?.toLowerCase(); // 'personal'
    // const matchingCategory = this.data.categories.find(
    //   (cat: any) => cat.title.toLowerCase() === defaultCatTitle
    // );

    // if (matchingCategory) {
    //   this.searchForm.patchValue({
    //     categories: matchingCategory.id
    //   });
    // }

    // When country changes, refresh documents
    this.searchForm.get('country')?.valueChanges.subscribe(country => {
      this.loadDocuments();  // a helper that calls correct API
      this.loadCategories()
    });

    // When category changes, refresh documents
    this.searchForm.get('categories')?.valueChanges.subscribe(category => {
      this.loadDocuments();
    });

  }

  loadCategories(): void {
    // Country selection UI has been removed from this dialog, so always use
    // the primary citizenship index rather than re-deriving it by matching
    // `this.citizen` against the (hidden) country value - a person can have
    // multiple citizen records sharing the same country, which could
    // previously resolve to the wrong index (e.g. "citizen_second").
    const selectedIndex = 'citizen_primary';

    this.authService.getTags(selectedIndex).subscribe((user: any) => {
      this.getCatgory = user.data.categories;
      // console.log('getCatgory', this.getCatgory)

      // Folder/category selection UI has been removed from this dialog -
      // it should always show the "LegalFinance" document list directly.
      // Fall back to the first available tag if "LegalFinance" isn't present.
      const defaultCategory = this.getCatgory.find((cat: any) => cat.tagname === 'LegalFinance')
        || this.getCatgory.find((cat: any) => cat.tagname);
      if (defaultCategory) {
        this.searchForm.patchValue({
          categories: defaultCategory
        });
        this.selectedCategories = [defaultCategory];
      }
    }); //get categories

    // Step 1: Get the tags with IDs first
    // const identityDocsCountStr = localStorage.getItem('identityDocsCount');
    // const identityDocsCount = identityDocsCountStr ? parseInt(identityDocsCountStr, 10) : 0;
    // this.documentCategories = [
    //   {
    //     id: 'identity',
    //     title: 'Identity',
    //     count: identityDocsCount,
    //     icon: 'person',
    //     isActive: true,
    //     // documentTypes: [{ value: 'aadhar', title: 'Aadhar' }, { value: 'passport', title: 'Passport' }, { value: 'driver_license', title: 'Driver License' }, { value: 'voterid', title: 'Voter Id' }
    //     // ]
    //   }
    // ];
    // this.authService.get_tags(this.index_country).subscribe({
    //   next: (tagRes: any) => {
    //     if (tagRes.error || !tagRes.data?.categories) {
    //       console.warn('No tag categories found');
    //       return;
    //     }

    //     const tagMap = new Map<string, string>(); // tagName → id
    //     tagRes.data.categories.forEach((cat: any) => {
    //       tagMap.set(cat.tagname, cat.id);
    //     });

    //     // Step 2: Now get the counts
    //     this.authService.get_tag_counts(this.index_country).subscribe({
    //       next: (countRes: any) => {
    //          console.log('get2nd call', countRes)
    //         if (!countRes.error && countRes.data?.counts) {
    //           const newCategories = countRes.data.counts.map((item: any) => ({
    //             id: tagMap.get(item.tagName) || '', // map tagName to ID
    //             title: item.tagName,
    //             count: item.count,
    //             // icon: this.getIconForTag(item.tagName),
    //             isActive: false,
    //             documentTypes: []
    //           }));

    //           // Append or update in documentCategories
    //           newCategories.forEach((newCat: any) => {
    //             const index = this.documentCategories.findIndex(
    //               existingCat => existingCat.title === newCat.title
    //             );
    //             if (index > -1) {
    //               this.documentCategories[index].count = newCat.count;
    //               this.documentCategories[index].id = newCat.id; // update ID if needed
    //             } else {
    //               this.documentCategories.push(newCat);
    //             }
    //           });
    //           this.getTagId = tagMap; // Store the tag ID map for later use
    //           // this.getTagId = newCategories
    //           console.log('Loaded document categories:', this.getTagId);
    //           console.log('Updated document categories:', this.documentCategories);
    //         }
    //       },
    //       error: err => {
    //         console.error('Failed to load category counts:', err);
    //       }
    //     });
    //   },
    //   error: err => {
    //     console.error('Failed to load tag IDs:', err);
    //   }
    // });
   }

  getDoctypeName(doctype: string): string {
    // console.log('Getting doctype name for:', doctype);
    return this.doctypeMap[doctype] || doctype;
  }

  getCitizenships() {
    this.authService.get_citizenship().subscribe((user: any) => {
      this.citizen = user.data.citizenships;
      //console.log('citi',this.citizen)

      // Set default citizen_primary country
      const primaryCitizen = this.citizen.find((c: any) => c.index === 'citizen_primary');

      if (primaryCitizen) {
        this.searchForm.patchValue({ country: primaryCitizen.country });
      }
    });

    // this.authService.get_primary_citizen_docs().subscribe((user: any) => {
    //   this.files = user.data.documents;
    // })

    // this.authService.shared_with_me(this.data.id).subscribe((user: any) => {
    //   this.files = user.data;
    // })

    // this.authService.shared_by_me(this.data.id).subscribe((user: any) => {
    //   this.files = user.data;
    // })
  }

  getIdentityCitizen() {
    this.authService.get_primary_citizen_docs().subscribe((user: any) => {
      this.files = user.data.documents;
      this.allFiles = [...this.files];
    })
  }

  // formatDate(dateStr: string): string {
  //   const date = new Date(dateStr);
  //   return date.toLocaleDateString('en-US', {
  //     month: 'short',
  //     day: '2-digit',
  //     year: 'numeric',
  //   });
  // }
  formatDate(dateStr: string): string {
    if (!dateStr) return ''; // empty string

    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return ''; // invalid date

    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
    });
  }


  formatSize(sizeInBytes: number): string {
    return `${Math.ceil(sizeInBytes / 1024)} KB`;  // or use MB if needed
  }

  // setActiveDocument(selected: any): void {
  //   console.log('Selected category:', selected);

  //   //let matchedId = selected.id;
  //   let matchedId = this.getTagId.get(selected.title);
  //   if (Array.isArray(this.getTagId)) {
  //     const match = this.getTagId.find(obj => Object.keys(obj)[0] === selected.title);
  //     if (match) {
  //       matchedId = match[selected.title];
  //     }
  //   }
  //   //console.log('Matched ID:', matchedId);

  //   this.documentCategories = this.documentCategories.map(card => ({
  //     ...card,
  //     isActive: card.id === matchedId,
  //   }));

  //   this.tagSelected = matchedId;
  //   console.log('tagSelected:', this.tagSelected);

  //   const selectedCountry = this.searchForm.get('country')?.value;
  //   const selectedCitizen = this.citizen.find(
  //     (c: any) => c.country === selectedCountry
  //   );
  //   const selectedIndex = selectedCitizen?.index || 'citizen_primary';

  //   if (this.tagSelected === 'identity' || selected.id === 'identity') {
  //     this.authService.get_primary_citizen_docs().subscribe((user: any) => {
  //       this.files = user.data.documents;
  //     });
  //   }
  //   else if (selected.id !== 'identity') {
  //     this.authService.get_personal_docs_tag(this.tagSelected, this.index_country).subscribe({
  //       next: (res: any) => { 
  //          this.files = res.data.documents;
  //       },
  //       error: () => {
  //         this.toast.error('Failed to load documents. Please try again later.');
  //       }
  //     });
  //   }
  //   else { }
  // }

  loadDocuments() {
    let categoryObj = this.searchForm.get('categories')?.value;
    const selectedCountry = this.searchForm.get('country')?.value;

    let queryParams = {"share_status": "unshared", "rel_id": this.data?.id};
    //console.log('queryParams', queryParams);

    if (!categoryObj || !selectedCountry) {
      this.allFiles = [];  // reset list
      return;
    }

    // Country selection UI has been removed from this dialog, so always use
    // the primary citizenship index rather than re-deriving it by matching
    // `this.citizen` against the (hidden) country value - a person can have
    // multiple citizen records sharing the same country, which could
    // previously resolve to the wrong index (e.g. "citizen_second").
    const selectedIndex = 'citizen_primary';

    if (selectedIndex) { //get only citizen_primary
      this.authService.getTags(selectedIndex).subscribe((user: any) => {
        this.getCatgory = user.data.categories;
      });//get call

      if (categoryObj?.tagname === 'Identity'){
          
        this.authService.get_identity_Reldoc(selectedIndex,queryParams).subscribe((user: any) => {
          this.files = user.data.documents;
          this.allFiles = [...this.files];
        });
      }
      else{
        this.authService.get_personal_Reldoc(categoryObj?.id, selectedIndex, queryParams).subscribe({
          next: (res: any) => {
            this.files = res.data.documents;
            this.allFiles = [...this.files];
          },
          error: () => {
            this.toast.error('Failed to load documents. Please try again later.');
          }
        });
      }
    }
    else {
      // console.log('else block')
      this.authService.get_personal_Reldoc(categoryObj?.id, selectedIndex, queryParams).subscribe({
        next: (res: any) => {
          this.files = res.data.documents;
          this.allFiles = [...this.files];
        },
        error: () => {
          this.toast.error('Failed to load documents. Please try again later.');
        }
      });
    }
  }

  onCategoryChange(categoryObj: any) {
    //console.log('onChange category', categoryObj)
    this.searchForm.patchValue({ categories: categoryObj }, { emitEvent: false });
    //this.loadDocuments();
  }

  onCountryChange(country: any) {
    //console.log('onChange country', country)
    this.searchForm.patchValue({ country }, { emitEvent: false });
    //this.loadDocuments();
  }

  compareCategory = (c1: any, c2: any) => {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  };   // to compare two category objects

  onSearch(): void {
    const query = this.searchForm.get('searchQuery')?.value?.toLowerCase() || '';
    if (!query) {
      this.allFiles = [...this.files]; // reset to full list if empty
      return;
    }

    this.allFiles = this.files.filter(file =>
      (file.filename && file.filename.toLowerCase().includes(query)) ||
      (file.name && file.name.toLowerCase().includes(query)) ||
      (file.doctype && file.doctype.toLowerCase().includes(query))
    );
  }

  sendRequest(connection: any) {
    this.dialogRef.close({
      ...connection,
      categories: this.selectedCategories
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  capitalizeFirstLetter(status: string): string {
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  }

  toggleSelection(file: any, event: Event) {
    const input = event.target as HTMLInputElement;
    const checked = input?.checked;
    const docObj = { docid: file.id, doctype: file.doctype };
    // console.log('Toggling selection for:', docObj, 'Checked:', checked);
    // console.log('Current selectedDocs2:', this.selectedDocs);

    if (checked) {
      this.selectedDocs.push(docObj);
    } else {
      this.selectedDocs = this.selectedDocs.filter(
        doc => doc.docid !== file.id || doc.doctype !== file.doctype
      );
    }
  }

  isSelected(fileId: any): boolean {
    return this.selectedDocs.some(doc => doc.docid === fileId);
  }

  selected_chart(id: any, doctype: any, index: any, event: any) {
    /// if(this.clickedname=="Identity"){
    var value_identity = { "doctype": "identity", "docid": id }
    if (event) {
      this.files.push(value_identity)
    } else if (!event) {
      this.files.splice(this.files.indexOf(value_identity), 1)

    }
    // } else {
    //   var value_personal = { "doctype" : "personal", "docid" : id }
    //   if(event){

    //     this.datai.push(value_personal)
    //   } else if(!event){
    //     this.datai.splice(this.datai.indexOf(value_personal),1)
    //   }
    // }
  }

  // onShare() {
  //   let selectedCategory = this.searchForm.get('categories')?.value;

  //   if (!selectedCategory) {
  //     this.toast.error("Please select category");
  //     return;
  //   }

  //   // If it's an array, use the first selected value
  //   if (Array.isArray(selectedCategory)) {
  //     selectedCategory = selectedCategory[0];
  //   }

  //   if (this.selectedDocs.length === 0) {
  //     this.toast.error("Please select at least one document");
  //     return;
  //   }

  //   console.log('Selected category:', selectedCategory);

  //   const payload = {
  //     documents: this.selectedDocs.map(doc => ({
  //       doctype: selectedCategory,
  //       docid: doc.docid
  //     }))
  //   };

  //   this.authService.share_realtionship_document(this.data.id, payload).subscribe({
  //     next: (res: any) => {
  //       if (res.error) {
  //         this.toast.error(res.msg);
  //       } else {
  //         this.toast.success(res.msg);
  //         this.onCancel();
  //       }
  //     },
  //     error: (err) => {
  //       const msg = err?.error?.msg || 'Something went wrong';
  //       this.toast.error(msg);
  //     }
  //   });

  // }


  onShare() {
    let selectedCategory = this.searchForm.get('categories')?.value;
    if (!selectedCategory) {
      this.toast.error("Please select category");
      return;
    }

    // If it's an array, use the first selected value
    if (Array.isArray(selectedCategory)) {
      selectedCategory = selectedCategory[0];
    }

    if (this.selectedDocs.length === 0) {
      this.toast.error("Please select at least one document");
      return;
    }
    //console.log('Selected category:', selectedCategory);

    const doctype = selectedCategory?.tagname === 'Identity' ? 'identity' : 'personal';
    //console.log('Using doctype:', doctype);

    const payload = {
      documents: this.selectedDocs.map(doc => ({
        doctype: doctype,
        docid: doc.docid
      }))
    };

    this.authService.share_realtionship_document(this.data.id, payload).subscribe({
      next: (res: any) => {
        if (res.error) {
          this.toast.error(res.msg);
        } else {
          this.toast.success(res.msg);
          this.onCancel();
        }
      },
      error: (err) => {
        const msg = err?.error?.msg || 'Something went wrong';
        this.toast.error(msg);
      }
    });
  }

  // onCountryChange(event: MatSelectChange) {
  //   const selectedCountry = event.value;
  //   console.log('Selected Country:', selectedCountry);
  // }

  getFlagUrl(country: string): string {
    // console.log('Getting flag URL for country:', country);
    if (!country) return '';

    const map: { [key: string]: string } = {
      India: 'in',
      USA: 'us',
      Canada: 'ca',
      Argentina: 'ar',
      Australia: 'au',
      Austria: 'at',
      Belgium: 'be',
      Bosnia: 'ba',
      Brazil: 'br',
      Bulgaria: 'bg',
      Chile: 'cl',
      China: 'cn',
      Croatia: 'hr',
      'Czech Republic': 'cz',
      Denmark: 'dk',
      Estonia: 'ee',
      Finland: 'fi',
      France: 'fr',
      Germany: 'de',
      Herzegovina: 'ba',
      Iceland: 'is',
      Indonesia: 'id',
      Israel: 'il',
      Italy: 'it',
      Latvia: 'lv',
      Lithuania: 'lt',
      Macedonia: 'mk',
      Malaysia: 'my',
      Mexico: 'mx',
      Moldova: 'md',
      Montenegro: 'me',
      Netherlands: 'nl',
      'New Zealand': 'nz',
      Norway: 'no',
      Poland: 'pl',
      Portugal: 'pt',
      Romania: 'ro',
      Serbia: 'rs',
      Singapore: 'sg',
      Slovakia: 'sk',
      Slovenia: 'si',
      'South Africa': 'za',
      'South Korea': 'kr',
      Spain: 'es',
      Sweden: 'se',
      Switzerland: 'ch',
      Turkey: 'tr',
      Ukraine: 'ua',
      'United Arab Emirates': 'ae',
      'United Kingdom': 'gb',
      'United States': 'us',
      UK: 'gb',
      UAE: 'ae',
      US: 'us'
    };

    const cleanedCountry = country.trim(); // remove leading/trailing spaces
    const code = map[cleanedCountry];

    return code ? `https://flagcdn.com/w40/${code}.png` : '';
  }

}